<template>
  <div class="container-fluid" :class="colorTheme" :style="paddingStyle">
    <template v-if="showLayout">
      <div class="container" :class="isUseLoadMoreBtn">
        <div class="container__body">
          <h5 class="container__title" v-if="title">{{ title }}</h5>
          <ul class="container__cards container__cards--column-4" data-column-count="4">
            <li class="container__card" v-for="course in courseList" :key="course.id" :data-id="course.itemId">
              <a
                class="card__container"
                :class="isPreviewMode && !course.slug ? 'card__error' : ''"
                :href="`/${course.slug}`"
                :target="isUseNewTab"
              >
                <div class="card__body">
                  <template v-if="course.imageBadge">
                    <div class="card__badge" :style="imageBadgeStyle(course)">
                      <div :style="innerBadgeStyle(course.badgeBackgroundColor)">
                        {{ course.imageBadge }}
                      </div>
                    </div>
                  </template>
                  <div class="card__image" :style="backgroundImageStyle(course.desktopCardAsset)" />
                  <ul class="card__labels">
                    <li v-for="(badge, index) in course.keywords" :key="index">{{ badge }}</li>
                  </ul>
                  <div class="card__text">
                    <strong class="card__title text--h6">{{ course.publicTitle }}</strong>
                    <p class="card__content">{{ course.publicDescription }}</p>
                  </div>
                </div>
              </a>
            </li>
          </ul>
        </div>
        <div class="container__footer">
          <div class="container__btn-group">
            <button class="container__load-more-btn" :style="loadMoreBtnStyle">
              {{ loadMoreBtnText }}
              <svg width="12" height="7" viewBox="0 0 12 7" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M11 1L6 6L1 1" :stroke="buttonColor" />
              </svg>
            </button>
          </div>
        </div>
      </div>
    </template>
    <template v-else-if="showWarningMessage">
      <h2 class="container__error">courseId를 잘못 입력하였습니다. 확인해주세요.</h2>
    </template>
  </div>
</template>

<script>
import api from './api';

export default {
  name: 'course-blog-app',
  props: [
    'paddingTop',
    'paddingBottom',
    'buttonColor',
    'courseProps',
    'loadMoreBtnText',
    'useLoadMoreBtn',
    'colorTheme',
    'useNewTab',
    'title',
  ],
  data() {
    return {
      courseList: [],
      showLayout: true,
    };
  },
  computed: {
    paddingStyle() {
      return {
        paddingTop: `${this.paddingTop / 10}rem`,
        paddingBottom: `${this.paddingBottom / 10}rem`,
      };
    },
    isUseNewTab() {
      return this.useNewTab === 'true' ? '_blank' : '';
    },
    isUseLoadMoreBtn() {
      return this.useLoadMoreBtn === 'true' ? 'container--more-btn' : '';
    },
    loadMoreBtnStyle() {
      return {
        borderColor: this.buttonColor,
        color: this.buttonColor,
      };
    },
    isPreviewMode() {
      return window.location.search.includes('?_token=test_token');
    },
    showWarningMessage() {
      return !this.showLayout && this.isPreviewMode;
    },
  },
  created() {
    this.courseList = this.courseProps;
  },
  async mounted() {
    try {
      const courses = await this.getCourseList();

      if (!courses.length) {
        this.courseList = [];
        return;
      }

      this.courseList = this.courseProps
        .filter((props) => courses.some((course) => this.filterBySlug(course, props)))
        .map((props) => {
          const course = courses.find((course) => course.id === Number(props.courseId));

          return { ...props, ...course, itemId: props.id ?? props.courseId };
        });
    } catch (err) {
      this.showLayout = false;
    }
  },
  methods: {
    filterBySlug(course, props) {
      const filter = course.id === Number(props.courseId);
      return this.isPreviewMode ? filter : filter && course.slug;
    },
    async getCourseList() {
      const courseIds = this.courseProps.map((course) => course.courseId);
      const {
        data: {
          data: { courses },
        },
      } = await api.findCoursesByIds(courseIds);

      return courses;
    },
    imageBadgeStyle({ badgeBackgroundColor, badgeTextColor }) {
      return {
        backgroundColor: badgeBackgroundColor,
        color: badgeTextColor,
      };
    },
    backgroundImageStyle(desktopCardAsset) {
      return {
        backgroundImage: `url(${desktopCardAsset})`,
      };
    },
    innerBadgeStyle(badgeBackgroundColor) {
      return {
        backgroundImage: `linear-gradient(90deg, rgba(255, 255, 255, .3) 0%, ${badgeBackgroundColor}`,
      };
    },
  },
};
</script>

<style scoped lang="scss">
.container {
  &__error {
    color: red;
    text-align: center;
  }
}

.card {
  &__badge {
    font-family: aRocket, sans-serif;
  }

  &__error {
    &::after {
      content: '페이지의 상태, 시작일, 종료일을 확인해주세요.';
      position: absolute;
      top: 0;
      display: flex;
      align-items: center;

      width: 100%;
      height: 100%;

      background-color: rgba(red, 0.7);

      font-weight: bold;
      font-size: 1.4rem;
      color: #fff;
      text-align: center;
    }
  }
}
</style>
